<template lang="pug">
BriqDialog(@close="$emit('close')")
  h2.h1.mb-S Hey, before you save this...
  span We see the following: 
  ul.ml-S
    li(v-if="quantityMismatch") a higher number of persons in one or more products than in total.
    li(v-if="segmentMismatch") a difference in number of segments in total and in one or more products.
    li(v-if="!conflictingScheduleValidation.isValid") booking products validations has failed for the following reasons: 
      ul.ml-S
        li(v-for="(field, fieldKey) in conflictingScheduleValidation.response" :key="fieldKey")
          span Product: {{ field.ProductName }}
          b.ml-XXXS ({{ getResourceName(field.Index) }})
          ul.ml-S
            li(v-for="(error, errorKey) in field.Errors" :key="errorKey") {{ error }}
  p.mb-S Do you still want to save?
  .button-bar.button-bar--center
    BriqButton.mr-XS(variant="secondary" ref="editBooking" @click="$emit('close')") Edit Booking
    BriqSubmitButton(@click="saveBooking" ref="saveBooking") Save booking
</template>

<script>
import { find } from 'ramda'
export default {
  name: 'WarningModal',
  props: {
    quantityMismatch: Boolean,
    segmentMismatch: Boolean,
    conflictingScheduleValidation: Object,
    booking: {
      type: Object,
      reqired: true,
    },
    resources: {
      type: Array,
      reqired: true,
    },
  },
  methods: {
    saveBooking() {
      this.$emit('saveBooking')
      this.$emit('close')
    },
    getResourceName(bookingProductIndex) {
      const bookingProduct = this.booking.BookingProducts[bookingProductIndex]
      const resource = find(r => r.Key === bookingProduct.ResourceKey)(this.resources)
      return resource.Description
    },
  },
}
</script>

<style lang="stylus">
.briq-dialog-backdrop > .briq-dialog
  max-height 97vh
  overflow-y auto
</style>
